// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckoutSidebarView_root__gmKiG","lineItemsList":"CheckoutSidebarView_lineItemsList__IeG8V"};